import React from 'react';

const HubSkeletonGrid = ({ count = 8 }) => (
  <div className="hub-grid" aria-busy="true" aria-label="Loading models">
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="hub-card hub-card--skeleton">
        <div className="hub-card__top">
          <div className="hub-skel hub-skel--icon" />
          <div className="hub-card__title-wrap">
            <div className="hub-skel hub-skel--line hub-skel--title" />
            <div className="hub-skel hub-skel--pill" />
          </div>
        </div>
        <div className="hub-skel hub-skel--line" />
        <div className="hub-skel hub-skel--line hub-skel--short" />
        <div className="hub-card__stats">
          <div className="hub-skel hub-skel--chip" />
          <div className="hub-skel hub-skel--chip" />
          <div className="hub-skel hub-skel--chip" />
        </div>
      </div>
    ))}
  </div>
);

export default HubSkeletonGrid;
